import React from 'react';
import CookieConsent from 'react-cookie-consent';

// routing
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// app style
import './App.scss';

// components
import Header from './components/Header';
import Footer from './components/Footer';

// pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import CookiesPolicy from './pages/CookiesPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import Admin from './pages/Admin';
import PrivateRoute from './pages/PrivateRoute';
import EditProject from './pages/EditProject';
import EditTestimonial from './pages/EditTestimonial';

//  API
import useFindUser from './hooks/useFindUser';
import { UserContext } from './hooks/UserContext';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
	const { user, setUser, isLoading, consent, setConsent } = useFindUser();
	return (
		<Router>
			<UserContext.Provider
				value={{ user, setUser, isLoading, consent, setConsent }}>
				<ScrollToTop />
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/login" element={<Login />} />
					<Route
						path="/admin"
						element={
							<PrivateRoute>
								<Admin />
							</PrivateRoute>
						}
					/>
					<Route
						path="/admin/projects/:id"
						element={
							<PrivateRoute>
								<EditProject />
							</PrivateRoute>
						}
					/>
					<Route
						path="/admin/testimonials/:id"
						element={
							<PrivateRoute>
								<EditTestimonial />
							</PrivateRoute>
						}
					/>
					<Route
						path="/policies/cookies"
						element={<CookiesPolicy />}
					/>
					<Route
						path="/policies/privacy"
						element={<PrivacyPolicy />}
					/>
				</Routes>
				<Footer />
				<CookieConsent
					location="bottom"
					flipButtons
					enableDeclineButton
					buttonText="I understand"
					declineButtonText="Decline"
					disableButtonStyles
					buttonWrapperClasses="px-4"
					buttonClasses="btn btn-light mx-2"
					declineButtonClasses="btn btn-danger mx-2"
					acceptOnScroll
					acceptOnScrollPercentage={25}
					cookieName="CookiesPolicy"
					style={{ background: 'rgb(40, 48, 67)' }}>
					This website uses cookies 🍪 to enhance the user experience.
					If you continue to navigate 🧭 this page, you accept our
					cookies policy.
				</CookieConsent>
			</UserContext.Provider>
		</Router>
	);
};

export default App;
